module.exports = __webpack_public_path__ + "static/img/ozy.22e9e9ce.png";